module.exports = __webpack_public_path__ + "4efdda5258159d0b50b9d28d4fb0e569.MP3";